import axios from "axios";

import { getApiUrl } from "../../core/config/api.js";

// All calls are marked silent so a transient failure (or a 403 for a
// non-master-admin) never triggers the global red banner — the page renders
// its own inline state instead.
const SILENT = { metadata: { silent: true } };

export async function fetchErrorGroups(params = {}) {
  const { data } = await axios.get(getApiUrl("/api/monitoring/errors"), {
    params,
    ...SILENT,
  });
  return data;
}

export async function fetchErrorGroup(id) {
  const { data } = await axios.get(getApiUrl(`/api/monitoring/errors/${id}`), SILENT);
  return data;
}

export async function updateErrorStatus(id, payload) {
  const { data } = await axios.patch(
    getApiUrl(`/api/monitoring/errors/${id}/status`),
    payload,
    SILENT
  );
  return data;
}

/** Resolve / ignore / reopen one beta-button report (same states as an error group). */
export async function updateBetaStatus(id, payload) {
  const { data } = await axios.patch(
    getApiUrl(`/api/monitoring/beta/${id}/status`),
    payload,
    SILENT
  );
  return data;
}

/**
 * Turn the human flag on or off for one error group.
 *
 * ON  — a person owns this error; the automation may diagnose but never push
 *       a fix for it.
 * OFF — the automation may prepare a fix and, if tests pass, merge to master
 *       (staging). Production release stays a human act either way.
 */
export async function updateHumanFlag(id, requiresHuman) {
  const { data } = await axios.patch(
    getApiUrl(`/api/monitoring/errors/${id}/human-flag`),
    { requires_human: requiresHuman },
    SILENT
  );
  return data;
}

/**
 * The incident memory. Incidents are captured automatically (resolving an
 * error or beta report, an auto-fix reaching staging, merged fix PRs) and
 * written up by Claude every night into knowledge/incidents/ in the backend
 * repo. These read the log, and let a person add one by hand.
 */
export async function fetchIncidents(params = {}) {
  const { data } = await axios.get(getApiUrl("/api/monitoring/incidents"), { params, ...SILENT });
  return data;
}

export async function fetchIncident(id) {
  const { data } = await axios.get(getApiUrl(`/api/monitoring/incidents/${id}`), SILENT);
  return data;
}

export async function createIncident(payload) {
  const { data } = await axios.post(getApiUrl("/api/monitoring/incidents"), payload, SILENT);
  return data;
}
